import React from 'react';
import CustomButton from '../../CustomButton'
import './HeroSectionClientes.css'

export function HeroSectionClientes() {
    return (
        <section className="hero-section-client">
            <div className="hero-container-client">
                <div className="hero-grid-client">
                    <div className="hero-content-client">
                        <span className="hero-badge-client">
                            <span className="material-icon">auto_awesome</span>
                            Cuidado com carinho
                        </span>
                        <h1 className="hero-title-client">
                            Mais carinho, menos correria.
                        </h1>
                        <p className="hero-description-client">
                            Banho para seu pet com preço previsível, agendamento fácil e parceiros verificados.
                        </p>
                        <div className="hero-buttons-client">
                            <CustomButton
                                variant="contained"
                                sx={{
                                    backgroundColor: '#FF914D',
                                    color: '#FFFFFF',
                                    padding: '12px 24px',
                                    fontSize: '15px',
                                    '&:hover': {
                                        backgroundColor: '#e67e3d',
                                    },
                                }}
                            >
                                <span className="material-icon">download</span>
                                Baixar para iOS
                            </CustomButton>

                            <CustomButton
                                variant="contained"
                                sx={{
                                    fontSize: '15px',
                                    padding: '12px 24px',
                                }}
                            >
                                <span className="material-icon">download</span>
                                Baixar para Android
                            </CustomButton>
                        </div>
                    </div>
                    <div className="hero-image-wrapper-client">
                        <img
                            src="/images/cachorro-mulher.png"
                            alt="Tutor feliz com cachorro limpo apos banho"
                            style={{ objectFit: "cover", width: '100%', height: '100%' }}
                        />
                    </div>
                </div>
            </div>
        </section>
    )
}